import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-cancel-changes-dialog',
  templateUrl: './confirm-cancel-changes-dialog.component.html',
  styleUrls: ['./confirm-cancel-changes-dialog.component.scss']
})
export class ConfirmCancelChangesDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
